import styled from 'styled-components'
import StyledGrid from 'components/styled-grid'

const StyledSiloManagementList = styled(StyledGrid)`  

  width: 100%;
  padding: 0px 8px 0 8px;

  .align-center {
    text-align: center;
  }
  
  .containerListaGradeDescarga {
    background-color: white;
    height: calc(100vh - 343px);
    width: 100%;
    overflow-y: auto;
  }  

  .rowListHeader {
    width: 100%;
  }
  
  .pagination {
    justify-content: flex-end;
  }
  
  .input-dias-uteis,
  .input-sabados,
  .input-domingos,
  .input-feriados {
      width:70px;
      flex-shrink: 0;
  }

  .no-results {
    font-size: 14px;
  }
  
  .pt-10 {
    padding-top: 10px;
  }
  
  .pb-10 {
    padding-bottom: 10px;
  }

  .hintList:hover .hintListComponent {
    display: block;
  }  
`

export default StyledSiloManagementList